'use client';
import { resetAdditionalData } from '@/redux/additionalDataSlice';
import { hideModal } from '@/redux/navigationSlice';
import { Button, Stack } from '@mui/material';
import type { Dispatch } from '@reduxjs/toolkit';
import { deleteClientCookie, getClientCookie } from '@repo/utils';
import { useDispatch } from 'react-redux';

/**
 * Drops the onboarding instance and client state, then reloads the landing.
 *
 * @param {Function} dispatch - Redux dispatch.
 */
export const restartFlow = (dispatch: Dispatch) => {
  deleteClientCookie([
    'instanceId',
    'requestedAmount',
    'integrationType',
    'policyProduct',
    'utmData',
    'orderToken',
    'accessKey',
  ]);
  dispatch(resetAdditionalData());
  //@todo - check if interval is needed
  const interval = setInterval(() => {
    if (!getClientCookie('instanceId')) {
      clearInterval(interval);
      // Full reload on purpose: drops client state before restarting
      // eslint-disable-next-line @next/next/no-location-assign-relative-destination
      window.location.href = '/';
    }
  }, 500);
};

/**
 * Renders a cancel body for a Modal component with flow reset logic. Staying is the primary action, as in mobile.
 *
 * @return {React.JSX.Element} The rendered ModalCancelBody component.
 */
export const ModalCancelBody = (): React.JSX.Element => {
  const dispatch = useDispatch();
  return (
    <>
      <Stack
        sx={{
          gap: 1,
          width: '100%',
          mt: 2,
        }}
      >
        <Button onClick={() => dispatch(hideModal())}>Seguir</Button>
        <Button
          variant="inverted"
          onClick={(e) => {
            e.preventDefault();
            restartFlow(dispatch);
          }}
        >
          Volver al inicio
        </Button>
      </Stack>
    </>
  );
};
